import { Link } from "react-router-dom";

interface SectionHeadProps {
  overline?: string;
  title: string;
  desc?: string;
  linkText?: string;
  linkTo?: string;
}

export default function SectionHead({
  overline,
  title,
  desc,
  linkText,
  linkTo,
}: SectionHeadProps) {
  return (
    <div className="mb-6 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {overline && (
          <div className="mb-1.5 flex items-center gap-2">
            <span className="h-[3px] w-5 rounded bg-primary-500"></span>
            <span className="text-xs font-medium tracking-widest text-primary-600">
              {overline}
            </span>
          </div>
        )}
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-[28px]">
          {title}
        </h2>
        {desc && (
          <p className="mt-2 max-w-2xl text-sm leading-6 text-foreground-600">
            {desc}
          </p>
        )}
      </div>
      {linkText && linkTo && (
        <Link
          to={linkTo}
          className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm text-primary-600 transition-colors hover:text-primary-700"
        >
          {linkText}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}